import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'iddat-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoginComponent implements OnInit {

  public loginLogoPath: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.loginLogoPath = this.route.snapshot.data['loginLogoPath'];
  }
}
